<template>
  <div class="hotspot-details px-1 py-1">
    <h6 class="mb-1">Affected Apps Details</h6>
    <div v-if="hasData">
      <p
        v-for="detail in formattedDetails"
        :key="detail.appId"
        class="hotspot-details-line mb-0-5"
      >
        {{ detail.text }}
      </p>
    </div>
    <div v-else-if="loaded">{{ $t("No Data Available") }}</div>
    <SpinnerCmpt v-else class="my-2"></SpinnerCmpt>
  </div>
</template>

<script>
import SpinnerCmpt from '@/xvisor/components/SpinnerCmpt.vue';

export default {
  components: {
    SpinnerCmpt,
  },
  props: {
    hotspotKey: {
      type: String,
      required: true,
    },
    timeRange: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      details: [],
      loaded: false,
    };
  },
  mounted() {
    this.httpGet();
  },
  watch: {
    hotspotKey() {
      this.httpGet();
    },
    timeRange() {
      this.httpGet();
    },
  },
  computed: {
    hasData() {
      return this.loaded && this.details && this.details.length > 0;
    },
    formattedDetails() {
      return this.details.map((detail) => ({
        appId: detail.appId,
        text: `${detail.appName} from ${this.formatZones(detail.zones)}`,
      }));
    },
  },
  methods: {
    httpGet() {
      if (!this.timeRange || !this.timeRange.start || !this.timeRange.end) {
        this.details = [];
        this.loaded = true;
        return;
      }
      this.loaded = false;
      this.$http
        .get(`/apps/hotspots/${this.hotspotKey}/details.json`, {
          params: {
            start: this.timeRange.start.toISOString(),
            end: this.timeRange.end.toISOString(),
          },
        })
        .then((response) => { this.details = response.data; })
        .finally(() => { this.loaded = true; });
    },
    formatZones(zones) {
      return zones.map((zone) => this.formatZone(zone)).join('; ');
    },
    formatZone(zone) {
      const zoneName = `Zone ${zone.zoneName}`;
      if (!zone.xomes || zone.xomes.length === 0) return zoneName;
      const xomeNames = zone.xomes.map((xome) => `Agent ${xome.xomeName}`).join(', ');
      return `${zoneName} (${xomeNames})`;
    },
  },
};
</script>

<style scoped>
.hotspot-details {
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 0.25rem;
  max-height: 75px;
  overflow-y: auto;
}

.hotspot-details-line {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.0;
}
</style>
